"use client";

import { buttonVariants } from "@sum-video/shared/components/ui/button";
import { cn } from "@sum-video/shared/utils/cn";
import { Moon, Sun } from "lucide-react";
import { useTranslations } from "next-intl";
import { useTheme } from "next-themes";
import type { JSX } from "react";

/**
 * A native <select> laid over the icon button: the OS picker handles the
 * menu, so no dropdown library ships with every page's header.
 */
export function ThemeSwitcher(): JSX.Element {
  const { theme, setTheme } = useTheme();
  const t = useTranslations("ThemeSwitcher");

  return (
    <div
      className={cn(
        buttonVariants({ variant: "outline", size: "icon" }),
        "relative has-[select:focus-visible]:ring-[3px] has-[select:focus-visible]:ring-ring/50",
      )}
    >
      <Sun
        aria-hidden
        className="h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-90"
      />
      <Moon
        aria-hidden
        className="absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0"
      />
      <select
        aria-label={t("toggleTheme")}
        value={theme ?? "system"}
        onChange={(event) => setTheme(event.target.value)}
        className="absolute inset-0 cursor-pointer opacity-0"
      >
        <option value="light">{t("light")}</option>
        <option value="dark">{t("dark")}</option>
        <option value="system">{t("system")}</option>
      </select>
    </div>
  );
}
